module.exports = __webpack_public_path__ + "static/media/advertise-category-page.14e2a05f.png";